import { ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTimeFormatter, LocalDate } from 'js-joda';

const parseToValidDate = (date: string): LocalDate | null => {
  try {
    return LocalDate.parse(date);
  } catch (error) {
    return null;
  }
};

const dateToString = (date: LocalDate): string => {
  return date.format(DateTimeFormatter.ofPattern('MM/dd/yyyy')).toString();
};

export function min(minDate: LocalDate): ValidatorFn {
  return (control): ForbiddenDateError => {
    const date: LocalDate = parseToValidDate(control.value);
    return date && minDate.isAfter(date)
      ? {
          forbiddenDate: {
            message: `Must be after ${dateToString(minDate)}.`
          }
        }
      : null;
  };
}

export function max(maxDate: LocalDate): ValidatorFn {
  return (control): ForbiddenDateError => {
    const date: LocalDate = parseToValidDate(control.value);
    return date && maxDate.isBefore(date)
      ? {
          forbiddenDate: {
            message: `Must be before ${dateToString(maxDate)}.`
          }
        }
      : null;
  };
}

export interface ForbiddenDateError extends ValidationErrors {
  forbiddenDate: {
    message: string;
  };
}
